import { css } from '@linaria/core';
import { Link } from '@tanstack/react-router';
import { Grid, Typography } from 'antd';
import classNames from 'classnames';

import { ROUTE_PATHS } from '@modules/route-paths';

import favicon from '../../config/assets/favicon.svg';
import logoDark from '../../config/assets/logo-dark.svg';
import logoLight from '../../config/assets/logo-light.svg';
import { APP_THEME_MODE } from '../../config/theme';
import { useAppTheme } from '../../config/theme/provider';

const styles = {
  logo: css`
    color: var(--ant-color-text);
    font-weight: 800;
    letter-spacing: -0.04em;
  `,
  image: css`
    height: 36px;
    object-position: center 27%;

    @media (max-width: 768px) {
      height: 28px;
    }
  `,
};

interface BrandLogoProps {
  className?: string;
  full?: boolean;
}

const BrandLogo = ({ className, full }: BrandLogoProps) => {
  const breakpoints = Grid.useBreakpoint();

  const { mode } = useAppTheme();
  const isDarkMode = mode === APP_THEME_MODE.DARK;

  return (
    <Typography.Text className={classNames(styles.logo, className)}>
      <Link to={ROUTE_PATHS.HOME}>
        {breakpoints.sm || full ? (
          <img
            className={styles.image}
            src={isDarkMode ? logoDark : logoLight}
            alt="Logo da NexoTCG"
            height={breakpoints.md ? 32 : 28}
            width={breakpoints.md ? 152 : 134}
          />
        ) : (
          <img
            className={styles.image}
            src={favicon}
            alt="Logo da NexoTCG"
            height={breakpoints.md ? 32 : 28}
            width={40}
          />
        )}
      </Link>
    </Typography.Text>
  );
};

export default BrandLogo;
